import { AddNotiForm } from "components";
import { useAppSelector } from "services/redux/store";
import { Card, customToaster } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

const CreateNotifications = () => {
    const mode = useAppSelector((state) => state.site.mode);
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/notifications",
            text: "Notifications"
        }
    ];

    const handleSave = () => {
        customToaster("success", "Notification Added", mode);
    };

    return (
        <section className="w-full h-full overflow-auto flex flex-col px-4 py-4 md:px-10 md:py-10">
            <div className="w-full text-center">
                <Breadcrumb breadcrumb={breadcrumb} currentPath="Add" />
            </div>
            <div className="w-full text-center">
                <h1 className="font-medium text-lg dark:text-white py-2">
                    Add Push Notification
                </h1>
            </div>
            <Card>
                <AddNotiForm handleSave={handleSave} />
            </Card>
        </section>
    );
};

export default CreateNotifications;
